import { Component, OnInit } from '@angular/core';
import { SystemService } from 'src/app/services/system.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';

@Component({
  templateUrl: './agenda-dict.component.html'
})
export class AgendaDictComponent implements OnInit {
  agendaCategList = [];

  displayState: any = {
    workingDiv: false,
    saveDisabled: false
  };


  constructor(private systemService: SystemService, private messageService: MessageService,
              private utilService: UtilitiesService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.loadAgendaCategoryList();
  }

  loadAgendaCategoryList() {
    this.displayState.workingDiv = true;
    this.systemService.getAgendaCategories().subscribe (data => {
      this.utilService.doAudit(data,'response from getAgendaCategories');
      if (data) {
        this.agendaCategList = data;
        this.displayState.workingDiv = false;
      }
    });
  }

  viewOrder() {
    // this.utilService.doAudit(this.agendaCategList,'list:');
  }
  saveCategoryOrder() {
    // return;
    this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
    // update order# for each item
    for (let i = 0; i < this.agendaCategList.length; i++)
    {
      this.agendaCategList[i].orderNumber = (i + 1);
    }
    this.utilService.doAudit(this.agendaCategList,'reordered list:');
    this.systemService.saveAgendaCategOrder(this.agendaCategList).subscribe (data => {
      // once we get a response, hide the Edit window
      this.displayState.saveDisabled = false;
      this.showInfo({ key: 'info', severity: 'info', detail: 'Order of Agenda Categories was updated.', summary: 'Info' });
      // refresh the grid/list
      this.loadAgendaCategoryList();
    });
    //
    return true;
  }


  cancelReOrder() {
    // cancel any changes and reload original list/order
    this.showToast({ key: 'toast', severity: 'info', detail: 'Changes were discarded and previously saved order was reloaded.', summary: 'Info' });
    this.loadAgendaCategoryList();
    return true;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }
  showInfo(myMsg: Message) {
    this.messageService.clear('info');
    this.messageService.add(myMsg);
  }

  clear() {
    this.messageService.clear();
  }

}
